module.exports = __webpack_public_path__ + "static/media/furniture-5.46060e15.jpg";